import { Injectable } from '@angular/core';

import * as moment from 'moment';
import 'moment/locale/pt-br';

@Injectable()
export class Localization {

    // Get the current date and converted it into the norwaygian format
    NorwegianDateFormat(): string {

        moment.locale('nb');
        return moment().format('ll');
    }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/helpers/localization.ts